module.exports = __webpack_public_path__ + "static/media/speaker_WorldGBC_CristinaGamboa.4ead527e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_WorldGBC_CristinaGamboa.jpg
// module id = 259
// module chunks = 0